import React from 'react';
import { Provider } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { PersistGate } from 'redux-persist/es/integration/react';
import Register from './screens/Register';
import GdprScreen from './screens/Register/GdprScreen';
import { connect } from 'react-redux';
// import './styles/main.css';
import { Provider as AlertProvider } from 'react-alert';
import CustomAlert from './screens/shared/CustomAlert';
import Version from './screens/Version';
import TokenSigningScreen from './screens/Register/TokenSigninScreen';
import ProcessPayment from './screens/Register/ProcessPayment';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
var pjson = require('../package.json');

Bugsnag.start({
    apiKey: '8b2eaba11951b145b9bc33821c07a37c',
    appVersion: pjson.version,
    maxBreadcrumbs: 100,
    maxEvents: 100,
    plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

const options = {
    position: 'bottom center',
    timeout: 5000,
    offset: '30px',
    transition: 'scale',
};
const App = props => {
    return (
        <ErrorBoundary>
            <Provider store={props.store}>
                <AlertProvider template={CustomAlert} {...options}>
                    <PersistGate persistor={props.persistor}>
                        <ConnectedRouter history={props.routerHistory}>
                            <div className="main">
                                <Switch>
                                    <Route path={'/token-signin'} component={TokenSigningScreen} props={props} />
                                    {/*<PrivateRoute path="/screen" component={ScreenComponent} isAuthenticated={props.state.auth.isAuthenticated}/>*/}
                                    <Route
                                        path={`/register/process-payment`}
                                        component={ProcessPayment}
                                        props={props}
                                    />
                                    <Route path="/register" component={Register} props={props} />
                                    <Route path="/gdpr" render={props => <GdprScreen {...this.props} />} />
                                    <Route path={'/form-version'} render={props => <Version />} />
                                </Switch>
                            </div>
                        </ConnectedRouter>
                    </PersistGate>
                </AlertProvider>
            </Provider>
        </ErrorBoundary>
    );
};

const mapStateToProps = state => ({
    state,
});

export default connect(mapStateToProps)(App);
